import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { gaWrapper } from 'helpers/analytics';
import s from './UpdateTimelineButton.scss';

const UpdateTimelineButton = props => {
  const {
    params,
    count,
    newCount,
    isGrid2Col,
    timelineRef,
    isWapView,
    btnClass,
  } = props;
  const getMoreRecords = () => {
    gaWrapper(
      'send',
      'event',
      props.gaCategory,
      'new_updates_prompt_button',
      '',
    );
    params.curpg = 1;
    props.getNewUpdates(params);
    if (timelineRef) {
      const heightFrmTp = timelineRef.offsetTop;
      const px = isWapView ? -50 : 150;
      window.scrollTo(0, heightFrmTp + px);
    }
  };
  useEffect(
    () => {
      const intervalId = setInterval(() => {
        props.updateCount(params);
      }, 15000);
      return () => {
        clearInterval(intervalId);
      };
    },
    [newCount, count],
  );
  if (newCount === 0 || newCount === count || newCount < count) return null;
  const newUpdatedCount = newCount - count;
  return (
    <button
      id="refresh-button"
      className={`${s.updateButton} ${btnClass} ${isGrid2Col ? '' : s.col2}`}
      onClick={getMoreRecords}
    >
      {`${
        newUpdatedCount < 9 ? `0${newUpdatedCount}` : newUpdatedCount
      } new Update${newUpdatedCount > 1 ? 's' : ''}`}
    </button>
  );
};

UpdateTimelineButton.propTypes = {
  params: PropTypes.shape({}).isRequired,
  count: PropTypes.number,
  newCount: PropTypes.number,
  updateCount: PropTypes.func,
  getNewUpdates: PropTypes.func,
  isGrid2Col: PropTypes.bool,
  timelineRef: PropTypes.element.isRequired,
  isWapView: PropTypes.bool,
  gaCategory: PropTypes.string,
  btnClass: PropTypes.string,
};
UpdateTimelineButton.defaultProps = {
  count: 0,
  newCount: 0,
  updateCount: () => {},
  getNewUpdates: () => {},
  isGrid2Col: false,
  isWapView: false,
  gaCategory: '',
  btnClass: '',
};

export default UpdateTimelineButton;
